import React, { Component } from "react"
import theme from "../styles/theme"
import styled from "@emotion/styled"

const Outer = styled.div`
  padding: 0 32px;
`
const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;
  align-items: center;
  max-width: ${theme.maxwidth.default};
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${theme.breakpoints.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`

const Contact = styled.div`
  h3 {
    margin: 0;
  }
  h4 {
    font-size: 1.4rem;
  }
`
const Header = styled.div`
  grid-column: span 3;
  @media (max-width: ${theme.breakpoints.desktop}) {
    grid-column: span 2;
  }
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-column: span 1;
  }
  h2 {
    margin: 0;
  }
`

export default class ContactColumn extends Component {
  render() {
    return (
      <Outer>
        <Container>
          <Header>
            <h2>Sales</h2>
          </Header>
          <Contact>
            <h3>Portland, USA office</h3>
            <a href="mailto:ussales@stackglobal.io">
              <h4>ussales@stackglobal.io</h4>
            </a>
          </Contact>
          <Contact>
            <h3>London, UK office</h3>
            <a href="mailto:uksales@stackglobal.io">
              <h4>uksales@stackglobal.io</h4>
            </a>
          </Contact>
          <Contact>
            <h3>Global Sales</h3>
            <a href="mailto:globalsales@stackglobal.io">
              <h4>globalsales@stackglobal.io</h4>
            </a>
          </Contact>
        </Container>
      </Outer>
    )
  }
}
